// extracted by mini-css-extract-plugin
export default {"wrap":"FE-z","fullWidth":"GE-z","hideOnDesktop":"HE-z","content":"IE-z","hasOpenedNav":"JE-z","crumbsList":"KE-z","dropdownsWrap":"LE-z"};